// Página de Suporte - Formulário de Ticket
import { useState } from 'react';
import { Card } from '../../components/common/Card';
import { Button } from '../../components/common/Button';
import { Input } from '../../components/common/Input';
import { Select } from '../../components/common/Select';
import { Breadcrumbs } from '../../components/layout/Breadcrumbs';
import { Send, HelpCircle, MessageSquare } from 'lucide-react';

export function Suporte() {
  const [formData, setFormData] = useState({
    assunto: '',
    categoria: '',
    prioridade: 'media',
    descricao: '',
    anexos: [] as File[],
  });
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Aqui seria enviado para o backend
    console.log('Ticket enviado:', formData);
    alert('Ticket enviado com sucesso! Entraremos em contato em breve.');
    setFormData({
      assunto: '',
      categoria: '',
      prioridade: 'media',
      descricao: '',
      anexos: [],
    });
  };
  
  return (
    <div className="space-y-6">
      <Breadcrumbs items={[{ label: 'Suporte' }]} />
      
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 flex items-center gap-2">
            <HelpCircle className="w-6 h-6" />
            Suporte
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Precisa de ajuda? Entre em contato conosco através do formulário abaixo.
          </p>
        </div>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Formulário */}
        <div className="lg:col-span-2">
          <Card>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 flex items-center gap-2">
              <MessageSquare className="w-5 h-5" />
              Criar Novo Ticket
            </h2>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Input
                  label="Assunto"
                  placeholder="Descreva brevemente o problema"
                  value={formData.assunto}
                  onChange={(e) => setFormData({ ...formData, assunto: e.target.value })}
                  required
                />
                <Select
                  label="Categoria"
                  value={formData.categoria}
                  onChange={(e) => setFormData({ ...formData, categoria: e.target.value })}
                  options={[
                    { value: '', label: 'Selecione uma categoria' },
                    { value: 'tecnico', label: 'Problema Técnico' },
                    { value: 'faturamento', label: 'Faturamento' },
                    { value: 'funcionalidade', label: 'Funcionalidade' },
                    { value: 'outro', label: 'Outro' },
                  ]}
                  required
                />
              </div>
              
              <Select
                label="Prioridade"
                value={formData.prioridade}
                onChange={(e) => setFormData({ ...formData, prioridade: e.target.value })}
                options={[
                  { value: 'baixa', label: 'Baixa' },
                  { value: 'media', label: 'Média' },
                  { value: 'alta', label: 'Alta' },
                  { value: 'urgente', label: 'Urgente' },
                ]}
              />
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Descrição
                </label>
                <textarea
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  rows={6}
                  placeholder="Descreva detalhadamente o problema ou dúvida..."
                  value={formData.descricao}
                  onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Anexos (opcional)
                </label>
                <input
                  type="file"
                  multiple
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  onChange={(e) => {
                    const files = Array.from(e.target.files || []);
                    setFormData({ ...formData, anexos: files });
                  }}
                />
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  Formatos aceitos: PDF, JPG, PNG (máx. 5MB por arquivo)
                </p>
              </div>
              
              <div className="flex gap-4 justify-end">
                <Button variant="secondary" type="button">
                  Cancelar
                </Button>
                <Button variant="primary" type="submit">
                  <Send className="w-4 h-4 mr-2" />
                  Enviar Ticket
                </Button>
              </div>
            </form>
          </Card>
        </div>
        
        {/* Informações de Contato */}
        <div className="space-y-6">
          <Card>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
              Informações de Contato
            </h3>
            <div className="space-y-4">
              <div>
                <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Email</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">suporte@financea1.com.br</p>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Telefone</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">(11) 3000-0000</p>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Horário de Atendimento</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Segunda a Sexta: 9h às 18h
                  <br />
                  Sábado: 9h às 13h
                </p>
              </div>
            </div>
          </Card>
          
          <Card>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
              Dúvidas Frequentes
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              Antes de criar um ticket, verifique se sua dúvida já está respondida em nossa FAQ.
            </p>
            <Button variant="secondary" className="w-full" onClick={() => window.open('/app/consultas', '_blank')}>
              Ver FAQ
            </Button>
          </Card>
        </div>
      </div>
    </div>
  );
}

